import React, { useEffect, useState } from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, TextField, Typography } from '@mui/material';
import Header from '../../components/Header';
import { getSupportRequests } from '../../api/axios';

const SupportRequests = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selected, setSelected] = useState(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const loadRequests = async () => {
            try {
                const response = await getSupportRequests();
                setRequests(response.requests || []);
            } finally {
                setLoading(false);
            }
        };

        loadRequests();
    }, []);

    const columns = [
        { field: 'id', headerName: 'ID', width: 80 },
        { field: 'firstName', headerName: 'First Name', flex: 1, minWidth: 120 },
        { field: 'lastName', headerName: 'Last Name', flex: 1, minWidth: 120 },
        { field: 'email', headerName: 'Email', flex: 1.4, minWidth: 220 },
        { field: 'phone', headerName: 'Phone', flex: 1, minWidth: 130 },
        { field: 'subject', headerName: 'Subject', flex: 1.2, minWidth: 180 },
        { field: 'message', headerName: 'Message', flex: 2, minWidth: 280 },
        { field: 'status', headerName: 'Status', flex: 1, minWidth: 120 },
        {
            field: 'createdAt',
            headerName: 'Submitted',
            flex: 1.2,
            minWidth: 170,
            valueGetter: ({ row }) =>
                row.createdAt ? new Date(row.createdAt).toLocaleString() : '',
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 80,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <IconButton
                    onClick={(e) => {
                        e.stopPropagation();
                        setSelected(params.row);
                        setOpen(true);
                    }}
                >
                    <VisibilityIcon />
                </IconButton>
            ),
        },
    ];

    return (
        <Box m="20px">
            <Header title="SUPPORT REQUESTS" subtitle="Messages submitted through Contact Support" />
            <Box height="72vh" sx={{
                '& .MuiDataGrid-root': { border: 'none' },
                '& .MuiDataGrid-row': { backgroundColor: '#fff', color: '#6e0506' },
                '& .MuiDataGrid-columnHeaders': { backgroundColor: '#fff', color: '#6e0506' },
                '& .MuiDataGrid-footerContainer': { bgcolor: (theme) => theme.palette.background.default },
            }}>
                <DataGrid
                    rows={requests}
                    columns={columns}
                    loading={loading}
                    getRowId={(row) => row.id}
                    components={{ Toolbar: GridToolbar }}
                    disableSelectionOnClick
                />
            </Box>
            {/* Detail modal */}
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle sx={{ color: '#6e0506', fontWeight: 'bold' }}>Support Request Detail</DialogTitle>
                <DialogContent dividers>
                    {selected && (
                        <Box
                            component="dl"
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(2, 1fr)',
                                gap: 2,
                                m: 0,
                            }}
                        >
                            <Box component="dt">
                                <b style={{ color: '#6e0506' }}>Name:</b>{' '}
                                {selected.firstName} {selected.lastName}
                            </Box>

                            <Box component="dd" sx={{ m: 0 }}>
                                <b style={{ color: '#6e0506' }}>Email:</b>{' '}
                                {selected.email}
                            </Box>

                            <Box component="dt">
                                <b style={{ color: '#6e0506' }}>Phone:</b>{' '}
                                {selected.phone}
                            </Box>

                            <Box component="dd" sx={{ m: 0 }}>
                                <b style={{ color: '#6e0506' }}>Subject:</b>{' '}
                                {selected.subject}
                            </Box>

                            <Box component="dt">
                                <b style={{ color: '#6e0506' }}>Status:</b>{' '}
                                {selected.status}
                            </Box>

                            <Box component="dd" sx={{ m: 0 }}>
                                <b style={{ color: '#6e0506' }}>Submitted:</b>{' '}
                                {selected.createdAt
                                    ? new Date(selected.createdAt).toLocaleString()
                                    : ''}
                            </Box>

                            {/* Full-width message */}
                            <Box
                                component="dt"
                                sx={{
                                    gridColumn: '1 / -1',
                                    width: '100%',
                                }}
                            >
                                <Box
                                    component="div"
                                    sx={{
                                        color: '#6e0506',
                                        fontWeight: 'bold',
                                        mb: 1,
                                    }}
                                >
                                    Message:
                                </Box>

                                <TextField
                                    multiline
                                    rows={5}
                                    value={selected.message || ''}
                                    disabled
                                    fullWidth
                                    variant="outlined"
                                />
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="primary">Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default SupportRequests;